import React, { useEffect } from 'react';

import isNil from 'lodash-es/isNil';

import { IBringgUuids } from '@rbi-ctg/frontend';
import { IServerOrder } from '@rbi-ctg/menu';
import { DeliveryStatus, useDeliveryOrderStatusQuery } from 'generated/graphql-gateway';
import Map from 'pages/order-confirmation/map';
import { useMemoAll } from 'utils/use-memo-all';

import DeliveryDetails from '../delivery-details';

import { Container, DeliveryDetailsContainer, MapContainer } from './styled';

interface IDeliveryOrderCard {
  serverOrder: IServerOrder;
}

const POLL_INTERVAL = 5000;
const FINAL_DELIVERY_STATUSES = [
  DeliveryStatus.ORDER_ABANDONED,
  DeliveryStatus.ORDER_CANCELLED,
  DeliveryStatus.ORDER_DROPPED_OFF,
  DeliveryStatus.ORDER_ERROR,
  DeliveryStatus.ORDER_TIMEOUT,
];

const DeliveryOrderCard = ({ serverOrder }: IDeliveryOrderCard) => {
  const { data, startPolling, stopPolling } = useDeliveryOrderStatusQuery({
    fetchPolicy: 'no-cache',
    variables: {
      id: serverOrder.rbiOrderId,
    },
    skip: isNil(serverOrder.rbiOrderId),
  });

  const delivery = data?.order?.delivery;
  const deliveryStatus = delivery?.status;
  // Needed to track bringg delivery driver coords
  const bringgUuids: IBringgUuids = useMemoAll({
    share_uuid: delivery?.shareUuid ?? undefined,
    order_uuid: delivery?.task?.uuid ?? undefined,
  });

  useEffect(() => {
    startPolling(POLL_INTERVAL);

    return () => stopPolling();
  }, [startPolling, stopPolling]);

  useEffect(() => {
    // Stop polling once the order reaches a final state
    if (deliveryStatus && FINAL_DELIVERY_STATUSES.includes(deliveryStatus)) {
      stopPolling();
    }
  }, [deliveryStatus, stopPolling]);

  return (
    <Container>
      <MapContainer>
        <Map bringgUuids={bringgUuids} serverOrder={serverOrder} />
      </MapContainer>

      {delivery && (
        <DeliveryDetailsContainer>
          <DeliveryDetails serverOrder={serverOrder} delivery={delivery} />
        </DeliveryDetailsContainer>
      )}
    </Container>
  );
};

export default DeliveryOrderCard;
